const deviceType = IsPC() ? 'pc' : 'mobile'
const host = process.env.NODE_ENV == 'development' ? 'https://jtcz.op.dianhun.cn' : 'https://m3guo.17m3.com/activity/202111/jtcz';
const domain = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:8080/' : 'https://www.m3guo.com/activity/202111/signup-a13465ad/';
const ActivityId = 5;

const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1) || window.location.hash.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}

const ajax_url_map = {
  login: host + '/oauth/dianhun_login' + '?url=' + encodeURIComponent(domain),
  logout: host + '/oauth/logout',
  onair: host + '/api/live/field/1', //直播间信息查询接口
  userInfo: host + '/oauth/login_state', //登录用户信息查询接口
  videolist: host + '/api/video/list', //视频列表查询接口
  matchlist: host + '/api/schedule/list', //赛程列表查询接口
  vcode: host + '/open/captcha/build', //生成图形验证码接口
  vcode_check: host + '/open/captcha/check', //图形验证码验证接口
  query: host + '/api/sign_up/player/info', //玩家信息查询接口
  confirm: host + '/api/sign_up/player/confirm', //队员确认接口
  creat: host + '/api/sign_up/team/create', //战队创建接口
  add: host + '/api/sign_up/substitutes/add', //添加候补接口
  players: host + '/api/sign_up/team/players', //根据登录用户查找所属战队成员接口
  code: host + '/api/sign_up/team/get', //根据战队码查询战队信息接口
  playInfo: host + '/api/sign_up/team/player/get', //根据战队ID及当前登录用户查询该队员信息接口
  word: host + '/open/sensitive/check' //敏感词验证接口
}

const ajax_states = {
  success: 0,
  missing: 401,
}

const bodyScroll = function (event) {
  event.preventDefault();
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param = function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
      '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

const equipScore_quire = 350000;

const formRules = {
  name: [{
      required: true,
      message: '*请输入战队名称',
      trigger: 'blur'
    },
    {
      min: 1,
      max: 5,
      message: '* 请输入字母数字汉字且长度在5个字符以内的名称',
      trigger: 'blur'
    }
  ],
  zid: [{
    required: true,
    message: '*请选择比赛大区',
    trigger: 'change'
  }],
  account: [{
    required: true,
    message: '*请输入游戏ID',
    trigger: 'blur'
  }],
  id: [{
    required: true,
    message: '*请输入游戏ID',
    trigger: 'blur'
  }],  
  nick: [{
    required: true,
    message: '* 当前游戏ID在该游戏大区没有角色',
    trigger: 'blur'
  }],
  nickName: [{
    required: true,
    message: '* 当前游戏ID在该游戏大区没有角色',
    trigger: 'blur'
  }],  
  corpName: [{
    required: true,
    message: '*当前游戏ID未加入军团或与队长所属军团不一致',
    trigger: 'blur'
  }],
  maxEquipScore: [{
      required: true,
      message: '当前账号的神兵值信息有误',
      trigger: 'blur'
    },
    {
      min: equipScore_quire,
      type: 'number',
      message: '*当前账号的神兵值不足35万',
      trigger: 'blur'
    }
  ],
  realName: [{
    required: true,
    pattern: /^[\u4e00-\u9fa5]+$/,
    message: '*请输入真实姓名，必须是中文',
    trigger: 'blur'
  }],
  phone: [{
    required: true,
    pattern: /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/,
    message: '* 请输入正确的11位手机号码',
    trigger: 'blur'
  }],
  idCard: [{
    required: true,
    pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
    message: '* 请输入正确的18位身份证号码',
    trigger: 'blur'
  }],
  qq: [{
    required: true,
    pattern: /^[0-9]{2,16}$/,
    message: '* 请输入正确的QQ号码',
    trigger: 'blur'
  }],
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
}, 
// {
//   "id": 17,
//   "name": "铜雀台(wegame1)"
// }, {
//   "id": 18,
//   "name": "凤仪亭(wegame2)"
// }
]

export default {
  bodyScroll,
  ajax_url_map,
  getQueryVariable,
  domain,
  param,
  deviceType,
  ActivityId,
  ajax_states,
  formRules,
  areaList,
  equipScore_quire,
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js